
const createComponent = (Klass, elements, context, options) => {

  return [...elements].map(element => new Klass(element, context, Object.assign({}, options)));
};

const createComponentFactory = (Klass) => {
  return createComponent.bind(null, Klass);
};

export default createComponentFactory;



// WEBPACK FOOTER //
// ./src/js/app/createComponent.js